module.exports = __webpack_public_path__ + "23d41bb74b2a02853f6b1bccfb9a2684.svg";